export default __webpack_public_path__ + "static/media/dashboard.58b305e3.svg";